// extracted by mini-css-extract-plugin
export var anchored = "component-module--anchored--49d3a";
export var ctaButtonContainer = "component-module--ctaButtonContainer--d1484";
export var ctaContainer = "component-module--ctaContainer--42433";
export var ctaHeadline = "component-module--ctaHeadline--78b9d";
export var ctaImageContainer = "component-module--ctaImageContainer--b65cf";
export var ctaImageWrapper = "component-module--ctaImageWrapper--5e4c1";
export var ctaLink = "component-module--ctaLink--5b963";
export var ctaSection = "component-module--ctaSection--7a653";
export var ctaTagline = "component-module--ctaTagline--ea491";
export var ctaTextContainer = "component-module--ctaTextContainer--a89e5";
export var lightColor = "component-module--lightColor--7f1b8";
export var subHeadline = "component-module--subHeadline--51036";